<template>
    <div class="ft-appuntamento" :class="classeStato" :title="appuntamento.titolo">
        <div class="ft-appuntamento-top">
            <span class="ft-appuntamento-numero">N° {{ appuntamento.numeroOrdine }}</span>
            <span v-if="mostraCodice && appuntamento.codicePrestazione" class="ft-appuntamento-codice">{{
                appuntamento.codicePrestazione }}</span>
            <span v-else-if="appuntamento.statoAttuale" class="ft-appuntamento-stato">{{ appuntamento.statoAttuale }}</span>
        </div>
        <div class="ft-appuntamento-data">{{ data }}</div>
        <div class="ft-appuntamento-ora">
            <b-icon icon="clock"></b-icon>
            {{ orario }}
        </div>
        <div class="ft-appuntamento-titolo" v-if="appuntamento.titolo && appuntamento.titolo != 'ACCESSI'">{{
            appuntamento.titolo }}</div>
    </div>
</template>

<script>
import moment from "moment";

/*
 * Card di un accesso/appuntamento: numero d'ordine, data, orario, titolo.
 * Il bordo sinistro segue lo stato (prenotato giallo, eseguito verde, altrimenti colore del tema).
 * Usata da AccettazioneSsnRicettaDettaglioComponent e dalla modale "Visualizza" delle prestazioni.
 */
export default {
    props: {
        appuntamento: {
            type: Object,
            required: true,
        },
        // in alto a destra mostra il codice prestazione invece dello stato
        mostraCodice: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        data() {
            const valore = this.appuntamento.dataOraInizio || this.appuntamento.dataRiferimento;
            return valore ? moment(valore).format("DD/MM/YYYY") : "--";
        },
        // "09:00 - 09:30", oppure solo "09:00" se inizio e fine coincidono
        orario() {
            const inizio = this.appuntamento.dataOraInizio ? moment(this.appuntamento.dataOraInizio).format("HH:mm") : this.appuntamento.dalleOre;
            const fine = this.appuntamento.dataOraFine ? moment(this.appuntamento.dataOraFine).format("HH:mm") : this.appuntamento.alleOre;
            return !fine || inizio === fine ? inizio : inizio + " - " + fine;
        },
        classeStato() {
            switch (this.appuntamento.statoAttuale) {
                case "PRENOTATO":
                    return "ft-appuntamento-prenotato";
                case "ESEGUITO":
                    return "ft-appuntamento-eseguito";
                default:
                    return "";
            }
        },
    },
};
</script>

<style scoped>
/* I colori seguono il tema del cliente (public/css/<cliente>); i valori dopo la virgola sono di riserva. */
.ft-appuntamento {
    --ft-accent: var(--bg-sidebar-item, #2ba7bd);
    --ft-border: #e3e8ee;
    --ft-muted: #6c757d;
    --ft-text: #323a46;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 140px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid var(--ft-border);
    border-left: 3px solid var(--ft-accent);
    border-radius: 6px;
    font-size: 11px;
    line-height: 1.35;
    transition: box-shadow 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.ft-appuntamento:hover {
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08);
    transform: translateY(-1px);
}

.ft-appuntamento-prenotato {
    border-left-color: #ffc107;
}

.ft-appuntamento-eseguito {
    border-left-color: #218838;
}

.ft-appuntamento-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.ft-appuntamento-numero {
    font-weight: 700;
    color: var(--ft-accent);
}

.ft-appuntamento-stato {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--ft-muted);
}

.ft-appuntamento-codice {
    padding: 0 6px;
    border-radius: 4px;
    font-family: var(--font-family-monospace, monospace);
    font-size: 10px;
    font-weight: 600;
    color: var(--ft-accent);
    background: #f7f9fb;
    border: 1px solid var(--ft-border);
}

.ft-appuntamento-data {
    font-size: 12px;
    font-weight: 600;
    color: var(--ft-text);
}

.ft-appuntamento-ora {
    color: var(--ft-muted);
    font-variant-numeric: tabular-nums;
}

.ft-appuntamento-titolo {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--ft-muted);
}
</style>
